<atomic-result-text #atomicresulttext></atomic-result-text>